import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { SpinnerType, LoadingService } from 'app/shared/services/loading.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-custom-loading-spinner',
  templateUrl: './custom-loading-spinner.component.html',
  styleUrls: ['./custom-loading-spinner.component.scss']
})
export class CustomLoadingSpinnerComponent implements OnInit, OnDestroy {
  @Input() fullScreen: boolean = true;
  @Input() backdrop: boolean = true;
  @Input() speed: number = 2.5;

  // Arrays para diferentes tipos de spinners
  bars = Array(15).fill(0).map((_, i) => i);
  dots = Array(8).fill(0).map((_, i) => i);
  pulseElements = Array(3).fill(0).map((_, i) => i);
  waveElements = Array(5).fill(0).map((_, i) => i);
  circleElements = Array(8).fill(0).map((_, i) => i);
  bouncingElements = Array(3).fill(0).map((_, i) => i);
  foldingElements = Array(4).fill(0).map((_, i) => i);
  cubeElements = Array(9).fill(0).map((_, i) => i);
  sphereElements = Array(3).fill(0).map((_, i) => i);
  textElements = 'LOADING'.split('').reverse().map((letter, index) => ({
    letter,
    index,
    initialLeft: (index * 12) + '%'
  }));

  // Colores vibrantes para las animaciones
  colors = [
    '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEAA7',
    '#DDA0DD', '#98D8C8', '#F7DC6F', '#BB8FCE', '#85C1E9',
    '#F8C471', '#82E0AA', '#F1948A', '#85C1E9', '#D7BDE2'
  ];

  currentSpinner: SpinnerType = 'bars';
  currentColors: string[] = [];
  private loadingSubscription: Subscription;
  private spinnerTypeSubscription: Subscription;

  constructor(public loadingService: LoadingService) { }

  ngOnInit() {
    // Suscribirse a los cambios del loading state
    this.loadingSubscription = this.loadingService.isLoading$.subscribe(
      isLoading => {
        if (isLoading) {
          this.handleSpinnerSelection();
        }
      }
    );

    // Suscribirse a los cambios del tipo de spinner
    this.spinnerTypeSubscription = this.loadingService.loadingSpinnerType$.subscribe(
      () => {
        this.handleSpinnerSelection();
      }
    );
  }

  ngOnDestroy() {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
    }
    if (this.spinnerTypeSubscription) {
      this.spinnerTypeSubscription.unsubscribe();
    }
  }

  private handleSpinnerSelection() {
    // Usar el getter público en lugar de acceder al subject directamente
    const requestedSpinner = this.loadingService.currentSpinnerType;

    if (requestedSpinner === 'random') {
      this.randomizeSpinner();
    } else {
      this.currentSpinner = requestedSpinner;
      this.generateRandomColors();
    }
  }

  randomizeSpinner() {
    const spinnerTypes: SpinnerType[] = [
      'bars', 'dots', 'pulse', 'wave', 'circle',
      'bouncing', 'folding', 'cube', 'spinning'
    ];

    this.currentSpinner = spinnerTypes[Math.floor(Math.random() * spinnerTypes.length)];
    this.generateRandomColors();
  }

  generateRandomColors() {
    const numColors = 3 + Math.floor(Math.random() * 3);
    this.currentColors = [];
    const shuffledColors = [...this.colors].sort(() => Math.random() - 0.5);

    for (let i = 0; i < numColors; i++) {
      this.currentColors.push(shuffledColors[i]);
    }
  }

  getRandomColor(index: number = 0): string {
    if (this.currentColors.length === 0) return '#ffffff';
    return this.currentColors[index % this.currentColors.length];
  }

  getAnimationDelay(index: number, total: number): number {
    return (index * 0.15) - (total * 0.15 / 2);
  }

  getBarsAnimationDelay(index: number): number {
    return (0.2 * (7 - index)) * (index < 8 ? 1 : -1);
  }

}
